import { Button, ChevronLeftIcon } from "@fanka/ui-admin";

export const GoBackViewButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Button styleType="textLine" icon={<ChevronLeftIcon />} iconType="left" size="lg" onClick={onClick}>
      戻る
    </Button>
  );
};
